var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VRow',[_c('VCol',{attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(_vm.$t('interviewAborted'))+" "),_c('a',{on:{"click":_vm.reload}},[_vm._v(_vm._s(_vm.$t('continue')))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }